module.exports = __webpack_public_path__ + "static/img/emoji_9.7b1a317d.png";